import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';

export default function MComparisonTable({ product1, product2 }) {
	const rows = [];
	const buildRows = ({ index }) => (
		<tr
			className="a-list-row--compare-table"
			key={get(product1, `productInfo.${index}.label`, '')}
		>
			<td>
				<p className="bold">
					<FormattedMessage id={get(product1, `productInfo.${index}.label`, '')} />
				</p>
			</td>
			<td><p>{get(product1, `productInfo.${index}.value`, '')}</p></td>
			<td><p>{get(product2, `productInfo.${index}.value`, '')}</p></td>
		</tr>
	);

	get(product1, 'productInfo', [])
		.forEach((item, index) => {
			if (!item.value) {
				return;
			}
			rows.push(buildRows({ index }));
		});


	return (
		<table className="m-compare-table">
			<thead>
				<tr>
					<th />
					<th className="table-title">{product1 ? product1.name : ''}</th>
					<th className="table-title">{product2 ? product2.name : ''}</th>
				</tr>
			</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	);
}

MComparisonTable.propTypes = {
	product1: PropTypes.any,
	product2: PropTypes.any,
};

MComparisonTable.defaultProps = {
	product1: undefined,
	product2: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.comparison-table.js